import axios from 'axios';
import { logout } from '../redux/actions/authActions';

const baseURL = process.env.REACT_APP_API_URL || 'https://song.appixi.net/api';

const axiosInstance = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Set initial token if it exists
const token = localStorage.getItem('access_token');
const tokenType = localStorage.getItem('token_type');
if (token) {
  axiosInstance.defaults.headers.common['Authorization'] = `${tokenType} ${token}`;
}

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (request) {
    const token = localStorage.getItem('access_token');
    const tokenType = localStorage.getItem('token_type');

    // Add Authorization header if the token exists
    if (token) {
      request.headers.Authorization = `${tokenType} ${token}`;
    }

    // Add 'is_admin=1' as a global request parameter
    if (!request.params) {
      request.params = {};
    }
    request.params.is_admin = 1;

    // If the data is FormData, don't set Content-Type header
    // Let the browser set it automatically with the boundary
    if (request.data instanceof FormData) {
      delete request.headers['Content-Type'];
    }

    return request;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response?.status === 401) {
      // Clear local storage and redirect to login
      localStorage.removeItem('access_token');
      localStorage.removeItem('token_type');
      localStorage.removeItem('expires_in');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 